import { _ } from "~/i18n";

interface ISuggestItemData {
	longitude?: number;
	latitude?: number;
	source?: string;
	id?: string | number;
	title: string;
	secondRow?: string;
	thirdRow?: string;
	phrase: string;
	iconType?: string;
	iconUrl?: string;
	poiTypeId?: number;
	mmid?: string | number;
	mmsource?: string;
	searchCategory?: string;
	highlight?: [number, number];
	highlightSecond?: [number, number];
	resultType?: string;
}

export default class SuggestProvider extends SMap.SuggestProvider {
	_phrase: string;

	constructor(options) {
		super(options);

		this._phrase = "";
	}

	get(phrase) {
		// jednorazovy test/stazeni dat pro ikonky
		if (this._iconTest) {
			this._iconTest = false;

			// test na data pro ikonky
			if (!this._iconsDataAvail()) {
				this._getIconData();
			}
		}

		this.abort();

		this._phrase = phrase;

		this._responseData = null;
		this._promise = new JAK.Promise();

		this._request = new JAK.Request(JAK.Request.TEXT, { withCredentials: true });
		if (this._options.abTest) {
			this._request.setHeaders({
				"X-AB-Feature": this._options.abTest,
			});
		}
		this._request.setHeaders({
			"X-SZN-Sdk": SMap.getSDKHeaderValue(),
		});
		if (SMap.apiKey) {
			const obj = {};

			obj[SMap.CONFIG.apiKeyHeader] = SMap.apiKey;
			this._request.setHeaders(obj);
		}
		this._request.send(this._getUrl(this._getUrlParams(phrase))).then(data => {
			this._responseData = data;

			// pokud nebezi request pro data ikonek, tak zpracuj zrovna
			if (!this._iconsRequest) {
				this._processData();
			}
		}, () => {
			this._promise.reject();
		});

		return this._promise;
	}

	_processData() {
		if (!this._responseData) {
			return;
		}

		const rawData = JSON.parse(this._responseData.data);

		if (rawData.result && Array.isArray(rawData.result)) {
			const resultsItems: Array<ISuggestItemData> = [];

			if (rawData.result.length) {
				rawData.result.forEach(item => {
					const poiTypeId = item.userData.poiTypeId || 0;
					const firstRow = (item.userData.suggestFirstRow || "").trim();
					let id = item.userData.id;

					if (item.userData.source === "coor" && typeof id === "number") {
						id = `${item.userData.longitude},${item.userData.latitude}`;
					}

					let itemData: ISuggestItemData = {
						longitude: parseFloat(item.userData.longitude),
						latitude: parseFloat(item.userData.latitude),
						source: item.userData.source,
						id: id,
						title: firstRow,
						secondRow: (item.userData.suggestSecondRow || "").trim(),
						thirdRow: (item.userData.suggestThirdRow || "").trim(),
						phrase: firstRow || item.sentence,
						iconType: item.userData.iconType || "",
						iconUrl: this._getIconUrl(poiTypeId),
						poiTypeId: poiTypeId,
						mmid: item.userData.mmid || 0,
						mmsource: item.userData.mmsource || "",
						searchCategory: item.category || "",
						highlight: item.userData.highlight,
						highlightSecond: item.userData.highlightSecond,
						resultType: item.userData.resultType,
					};

					// vlastni funkce pro upravu dat
					if (typeof this._options.dataParams === "function") {
						if (this._options.dataParams(itemData, item) === null) {
							itemData = null;
						}
					}

					if (itemData) {
						resultsItems.push(itemData);
					}
				});
			} else {
				resultsItems.push({
					title: `<span>${_("search")}</span> <i>„${Mapy.Util.escapeHTML(this._phrase)}“</i>`,
					resultType: "zero_suggest",
					iconType: "zero-suggest",
					phrase: this._phrase,
				});
			}

			this._promise?.fulfill(resultsItems);
		}

		this._promise = null;
		this._request = null;
	}
}
